module.exports = __webpack_public_path__ + "static/media/1008083.1f8f0468.png";